import { useTagFollows } from "@/hooks/useTagFollows";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { X, Tag as TagIcon } from "lucide-react";
import { Link } from "react-router-dom";

export function FollowedTagsList() {
  const { followedTags, loadingTags, unfollowTag, isUnfollowingTag } = useTagFollows();

  if (loadingTags) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="animate-pulse space-y-3">
            <div className="h-5 w-32 bg-muted rounded" />
            <div className="flex flex-wrap gap-2">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-8 w-24 bg-muted rounded" />
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (followedTags.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <TagIcon className="h-5 w-5" />
            Followed Tags
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <TagIcon className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground mb-4">
              You're not following any tags yet
            </p>
            <Link to="/tags">
              <Button>Discover Tags</Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TagIcon className="h-5 w-5" />
          Followed Tags ({followedTags.length})
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          You'll be notified when highly-rated books are tagged with these
        </p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {followedTags.map((tag) => (
            <Badge
              key={tag.tag_name}
              variant="secondary"
              className="flex items-center gap-2 py-2 px-3"
            >
              <Link
                to={`/tags?tag=${encodeURIComponent(tag.tag_name)}`}
                className="hover:underline"
              >
                {tag.tag_name}
              </Link>
              <Button
                variant="ghost"
                size="icon"
                className="h-4 w-4 p-0 hover:bg-transparent"
                onClick={() => unfollowTag(tag.tag_name)}
                disabled={isUnfollowingTag}
              >
                <X className="h-3 w-3" />
              </Button>
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
